import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "app/service/auth/auth.service";

@Component({
  selector: 'app-help-board',
  templateUrl: './help-board.component.html',
  styleUrls: ['./help-board.component.scss']
})
export class HelpBoardComponent {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
  ) {
    this.route.queryParams.subscribe(
      params => {
        this.location = params['location'] ? params['location'] : ''
        this.search = params['search'] ? params['search'] : ''
      })
  }

  reload() {
    let url = this.router.url.split('?')[0];
    this.router.navigateByUrl(`${url}?` + (this.location ? `&location=${this.location}` : '') + (this.search ? `&search=${this.search}` : ''));
  }

  search: string;
  onSearch(term: string) {
    this.search = term;
    this.reload();
  }

  location: string;
  onLocation(location: string) {
    this.location = location
    this.reload();
  }

  isAdmin() {
    return this.authService.isAdmin();
  }

}



// WEBPACK FOOTER //
// ./src/app/member/help-board/help-board.component.ts